import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import { Field } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

import { required } from '../../lib/validators';
import LocationTree from "./LocationTree";
import AddOrganization from "./AddOrganization";

const CustomerForm = (props) => {
    const {handleSubmit, branches, removeLink, removeLinkOrg,  fetchLocations, countries, deleteCustomer, onCountryChanged, loadServers, servers, customer, addLink, addLinkOrg, formData} = props;

    console.log(customer);

    return (
        <form onSubmit={handleSubmit}>
            <Grid fluid>
                <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <h2>Edit Customer</h2>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <div style={{textAlign: 'right', marginTop: '15px'}}>
                            <RaisedButton type="submit" primary={true} backgroundColor="#fff" label="Save" style={{margin: '5px'}} />
                            {customer && customer.id !== undefined &&  <RaisedButton type="button" backgroundColor="#fff" label="Delete" onTouchTap={deleteCustomer} style={{margin: '5px'}} />}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4} sm={4} md={4} lg={4} >
                        <div>
                            <Field name="name" validate={[required]} component={TextField} hintText="Name" floatingLabelText="Name" />
                        </div>
                        <div>
                            <Field name="adress1" validate={[required]} component={TextField} hintText="Address 1" floatingLabelText="Address 1" />
                        </div>
                        <div>
                            <Field name="adress2" validate={[required]} component={TextField} hintText="Address 2" floatingLabelText="Address 2" />
                        </div>
                        <div>
                            <Field
                                name="countryCode"
                                component={SelectField}
                                hintText={"Country"}
                                fullWidth={false}
                                floatingLabelText={"Country"}
                                onChange={onCountryChanged}
                                validate={[required]}>
                                {countries?countries.map(country => <MenuItem key={country.countryCode} value={country.countryCode} primaryText={country.name} />):[]}
                            </Field>
                        </div>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4}>
                        <Field
                            name="locations"
                            component={props => {
                                return (
                                    <Table fixedHeader={true}>
                                        <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                                            <TableRow>
                                                <TableHeaderColumn colSpan="12">
                                                    CashControl Links
                                                </TableHeaderColumn>
                                            </TableRow>
                                            <TableRow colSpan="6">
                                                <TableHeaderColumn colSpan="4">ID</TableHeaderColumn>
                                                <TableHeaderColumn colSpan="4">Name</TableHeaderColumn>
                                                <TableHeaderColumn colSpan="4">Drop</TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody showRowHover={true} displayRowCheckbox={false}>
                                            {props.input.value.map((location, index) => (
                                                    <TableRow key={location.id}>
                                                        <TableRowColumn colSpan="4">{location.id}</TableRowColumn>
                                                        <TableRowColumn colSpan="4">{location.locationName || location.name}</TableRowColumn>
                                                        <TableRowColumn colSpan="4">
                                                            {location.name && <RaisedButton primary onClick={() => removeLink(index)} label="Drop" />}
                                                        </TableRowColumn>
                                                    </TableRow>
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                )
                            }}
                            />
                        <div style={{marginBottom: "5px"} }>
                            <LocationTree onServerChanged={(serverId)=>{fetchLocations(serverId)}} nodes={props.tree} formData={formData} servers={servers}
                                          handleClose={(nodeId)=>{addLink(nodeId)}} loadServers={loadServers}/>
                        </div>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4} >
                        {props.organizations && <Field
                            name="organizations"
                            component={props => {
                                return (
                                    <Table fixedHeader={true}>
                                        <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                                            <TableRow>
                                                <TableHeaderColumn colSpan="12">
                                                    Safepoint Store Link
                                                </TableHeaderColumn>
                                            </TableRow>
                                            <TableRow colSpan="6">
                                                <TableHeaderColumn colSpan="4">ID</TableHeaderColumn>
                                                <TableHeaderColumn colSpan="4">Drop</TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody showRowHover={true} displayRowCheckbox={false}>
                                            {props.input.value.map((organization, index) => (
                                                    <TableRow key={organization.id}>
                                                        <TableRowColumn colSpan="4">{organization.id}</TableRowColumn>
                                                        <TableRowColumn colSpan="4">
                                                            {!organization.customerId && <RaisedButton primary onClick={() => removeLinkOrg(index)} label="Drop" />}
                                                        </TableRowColumn>
                                                    </TableRow>
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                )
                            }}
                        />}
                        {props.organizations && props.organizations.length === 0 &&
                        <div style={{marginBottom: "5px"} }>
                            <AddOrganization formData={formData} servers={servers}
                                          handleClose={(organization) => {addLinkOrg(organization)}}/>
                        </div>
                        }
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div>
                            <Table 
                                   fixedHeader={true}>
                                <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                                    <TableRow>
                                        <TableHeaderColumn colSpan="2" style={{textAlign: 'left'}}>
                                            Branches
                                        </TableHeaderColumn>
                                    </TableRow>
                                    <TableRow>
                                        <TableHeaderColumn>ID</TableHeaderColumn>
                                        <TableHeaderColumn>Name</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody showRowHover={true} displayRowCheckbox={false}>
                                    {branches?branches.map((branch, index) =>(
                                            <TableRow key={index}>
                                                <TableRowColumn>{branch.id}</TableRowColumn>
                                                <TableRowColumn>{branch.name}</TableRowColumn>
                                            </TableRow>
                                        )
                                    ):[]}
                                </TableBody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </Grid>
        </form>
    )
};

export default CustomerForm;


// WEBPACK FOOTER //
// ./src/components/customerForm/CustomerForm.js